import {
    DEALERDSRTRANSACTIONEXCELPDFFILE_FAILED,
    DEALERDSRTRANSACTIONEXCELPDFFILE_SUCCESS,
    RESET_DEALERDSRTRANSACTIONEXCELPDFFILE,
    LOADING_DEALERDSRTRANSACTIONEXCELPDFFILE,
    NETWORK_ERROR_DEALERDSRTRANSACTIONEXCELPDFFILE
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERDSRTRANSACTIONEXCELPDFFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERDSRTRANSACTIONEXCELPDFFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERDSRTRANSACTIONEXCELPDFFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERDSRTRANSACTIONEXCELPDFFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERDSRTRANSACTIONEXCELPDFFILE:
            return (state = initialState);
        default:
            return state;
    }
};